import * as React from "react";
import { observer } from "mobx-react";
import {
  makeStyles,
  SnackbarContent,
  useTheme,
  Snackbar,
  Box,
} from "@material-ui/core";
import { SvgIcon } from "../../../../components";
import { MessageType } from "../../../../components/Notifier/store";

interface IProps {
  inline?: boolean;
  note?: {
    messageType: MessageType;
    message: string;
    hideIcon?: boolean;
  };
  left?: boolean;
  onClose?: () => void;
}

export const SnackbarNotifierClosable = observer((props: IProps) => {
  const theme = useTheme();

  const classes = makeStyles({
    root: theme.overrides.MuiSnackbarContent.root,
    success: {
      backgroundColor: theme.palette.success.light,
      borderColor: theme.palette.success.dark,
      color: theme.palette.success.contrastText,
    },
    error: {
      backgroundColor: theme.palette.error.light,
      borderColor: theme.palette.error.dark,
      color: theme.palette.error.contrastText,
    },
    info: {
      backgroundColor: theme.palette.info.light,
      borderColor: theme.palette.info.dark,
      color: theme.palette.info.contrastText,
    },
    warning: {
      backgroundColor: theme.palette.warning.light,
      borderColor: theme.palette.warning.dark,
      color: theme.palette.warning.contrastText,
    },
  })({});

  return props.note ? (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      open={true}
    >
      <SnackbarContent
        classes={{ root: classes[props.note.messageType] }}
        message={
          <>
            {props.note.message}
            {props.note.hideIcon ? null : (
              <Box
                className="svgicon-notification inNotice"
                onClick={props.onClose}
              >
                <SvgIcon type={`search-clear`} />
              </Box>
            )}
          </>
        }
      />
    </Snackbar>
  ) : null;
});
